import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';

export function removeReturnBookingModal(
	departureBooking: boolean,
	onConfirm: (removeReturn: boolean, departureBooking: boolean) => void | Promise<void>,
) {
	return newConfirmModal(
		'Remove booking',
		<div>
			<h5>
				<FormattedMessage
					id="cart__remove-return-modal__body"
					defaultMessage="Would you like to remove the one-way trip only, or both trips?"
				/>
			</h5>
		</div>,
		{
			cancelText: 'One way',
			confirmText: 'Both trips',
			resolveOnCancel: true,
			resolveOnClose: true,
			shouldCloseOnEsc: false,
			shouldCloseOnOverlayClick: false,
			showCloseButton: true,
		},
	)
		// The user closed or dismissed this modal — newConfirmModal rejects with no value. Caught
		// here, and only here, so it doesn't mask a failure from onConfirm below.
		.catch(() => undefined)
		.then(result => {
			if (typeof result !== 'boolean') {
				return undefined;
			}
			// Returned, not fired and forgotten: onConfirm is async, and dropping its promise made
			// every rejection inside it (including the nested confirm modal's cancel) an unhandled
			// rejection with no stack — GlitchTip issue 82.
			return onConfirm(result, departureBooking);
		});
}
